import React from 'react'
import {
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Box,
    CloseButton,
} from '@chakra-ui/react'
import { AlertProps } from '../../../utils/types/props.alert'

const AppAlertOne = ({ status, title, body, onClose, variant }: AlertProps) => {
    return (
        <Alert status={status} variant={variant}>
            <AlertIcon />
            <Box flex="1" textAlign="left">
                <AlertTitle textAlign="left">{title}</AlertTitle>
                <AlertDescription
                    textAlign="left"
                    style={{ textAlign: 'left' }}
                >
                    {body}
                </AlertDescription>
            </Box>
            <CloseButton
                position="absolute"
                right="8px"
                top="8px"
                onClick={onClose}
            />
        </Alert>
    )
}

export default AppAlertOne
